export const UserIcon = () => (
  <svg
    className="ptm-centralized"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
  >
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M6 7.106c2.945 0 5.333 2.49 5.333 5.56H.667c0-3.07 2.388-5.56 5.333-5.56zM6 0c1.657 0 3 1.4 3 3.128 0 1.727-1.343 3.127-3 3.127s-3-1.4-3-3.127C3 1.4 4.343 0 6 0z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./components/userIcon/index.js